.productGridContainer {
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.image {
  height: 164px;
  margin-bottom: 16px;
}

.productText {
  height: 24px;
  max-width: 240px;
}

.addToCart {
  margin-top: 24px;
  height: 48px;
  max-width: 240px;
}

@media all and (--reefer-media-tablet-min) {
  .productGridContainer {
    gap: 26px;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }

  .image {
    height: 240px;
    width: 240px;
    margin-bottom: 24px;
  }
}
